import styled from 'styled-components';
import { Tag } from 'antd';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';

export const StyledInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
`;

export const StyledTagsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const StyledTag = styled(Tag)`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  color: ${COLORS.BLACK_PRIMARY};
  background: ${COLORS.BRIGHT_GRAY};
  border: none;
  border-radius: 1.5625rem;
  padding: 0.5rem 1rem;
  margin: 0;
`;

export const StyledTagRemoveButton = styled(Button)`
  &&& {
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${COLORS.BRIGHT_GRAY};
    border: 1px solid ${COLORS.BLACK_PRIMARY};
    border-radius: 50%;
    width: 1.5rem;
    height: 1.5rem;
    padding: 0;
    margin: 0;

    &&& svg {
      width: 0.75rem;
      height: 0.75rem;
    }

    &&&:hover {
      background: ${COLORS.BRIGHT_GRAY};
    }
  }
`;
